import { t } from "../../../languages";
import { CrownOutlined } from '@ant-design/icons';
import { Avatar, Badge, List } from 'antd';

import './index.less';
import Points from "../Points";
import { getColorFromName } from "../../../utils";


const Scoreboard = ({ lang, scores }) => {

  return (
    <div className="scoreboard-container">
      <h2 className="scoreboard-title">
        <Points /> {t(lang, 'scoreboard')}
      </h2>
      <List
        dataSource={scores}
        renderItem={(item, index) => (
          <List.Item className="scoreboard-item">
            <List.Item.Meta
              avatar={
                <div
                  className="student-avatar"
                  style={{ backgroundColor: getColorFromName(index) }}
                >
                  {item.avatar ? <img src={`./static/avatar/${item.avatar}.jpg`} alt="" /> : item.name.charAt(0).toUpperCase()}
                </div>
              }
              title={<span className="student-name">{item.name}</span>}
            />
            <div className={`score-points p${index}`}>
              <span className='points'><img src="./static/myspace/coin.svg" alt="" /> {item.points}</span>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

// Datos de ejemplo
Scoreboard.defaultProps = {
  scores: [
    { name: 'Ana López', points: 2450 },
    { name: 'Carlos Mendoza', points: 2100 },
    { name: 'Diana Torres', points: 1980 },
    { name: 'Luis Gómez', points: 1870 },
    { name: 'Sofía Ramírez', points: 1760 },
  ],
};

export default Scoreboard;